import { Entity } from '@/store/shared/entity'
import LogisticsName from './logisticsname'
import Total from './total'

export default class FreightForwarderTowingContainerStatistics extends Entity<number>{
    freightForwarderTowingContainerStatistics:Array<Total>;
    totalLogistics:Array<LogisticsName>;
}